<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" :id="`${id}-modal`" tabindex="-1" role="dialog" aria-labelledby="uploadModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uploadModalLabel">Select a file to upload</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form" v-if="!isLoading">
              <div class="custom-file text-center">
                <input type="file" id="file" class="custom-file-input" @change="fileChanged">
                <img v-if="image" height="100" :src="image" class="m-auto img-thumbnail custom-file-control">
              </div>
              <div v-if="type === 'file' && fileToUpload" class="custom-file-control m-auto">
                {{ [fileToUpload.name, fileToUpload.type, fileToUpload.size].join(' - ') }}
              </div>
            </form>
            <div class="text-center my-5" v-if="isLoading">
              Loading...
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-bind:disabled="!fileToUpload" :class="{'disabled': !fileToUpload}" v-on:click="upload()">Upload</button>
          </div>
        </div>
      </div>
    </div>
    <!-- IMAGE -->
    <div class="box text-center" v-if="type === 'image'" :style="{width: width, 'min-height': height}" @click="actionModal('show')">
      <span class="box-action-icon" :style="{'line-height': height}" v-if="!(show && value)">
        <i class="fa fa-plus fa-2x text-primary" aria-hidden="true"></i>
      </span>
      <img v-if="show && value" :src="value.slug | media({width: width})" class="img-thumbnail">
    </div>
    <!-- FILE -->
    <div class="box text-center" v-if="type === 'file'" :style="{width: width, 'min-height': height}" @click="actionModal('show')">
      <span class="box-action-icon" :style="{'line-height': height}" v-if="!(show && value && value.slug)">
        <i class="fa fa-file fa-2x text-primary" aria-hidden="true"></i>
      </span>
      <!-- Display file info -->
      <dl class="dl-horizontal" v-if="show && value">
        <dt>Name</dt>
        <dd>{{ value.name }}</dd>
        <dt>Type</dt>
        <dd>{{ value.type }}</dd>
      </dl>
    </div>
  </div>

</template>

<style scoped>
.dl-horizontal dd {
  margin: 0;
  padding: 0;
}
.dl-horizontal dt {
  text-align: center;
}
.custom-file {
  position: static;
  height: 100%;
  width: 100%;
  background-image: url('/beta/static/upload-1.gif');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.custom-file-control {
  height: 170px !important;
  background-color: #e5edf1;
  padding: 0;
  top: -35px;
  position: absolute;
  width: 94%;
  left: 15px;
}
.custom-file-input {
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.custom-file-control:lang(en):empty::after {
  content: none;
}
.custom-file-control:lang(en)::before {
  display: none;
}
.modal-form {
  height: 100px;
}

.box:hover {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
  border-color: #20a0ff;
  cursor: pointer;
}

.box {
  border: 1px solid #97a8be;
  background-color: lightgrey;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.117647),
    0 1px 4px rgba(0, 0, 0, 0.117647);
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>


<script>
import $ from 'jquery'
import Spinner from '@/components/Spinner'

export default {
  name: 'UploadFileInput',
  components: { spinner: Spinner },
  props: {
    value: Object,
    type: { type: String, default: 'image' },
    width: { default: 'auto' },
    height: { default: '100px' },
    id: { type: String, default: 'upload-file' },
    show: { type: Boolean, default: true }
  },
  data() {
    return {
      image: null,
      file: null,
      fileToUpload: null,
      isLoading: false
    }
  },
  watch: {
    fileToUpload: function(val) {
      if (this.type === 'image') this.createImage(val)
    }
  },
  methods: {
    actionModal(action = 'show') {
      this.fileToUpload = null
      this.image = null
      $(`#${this.id}-modal`).modal(action)
    },
    fileChanged(e) {
      e.preventDefault()
      this.fileToUpload = e.target.files[0]
      console.log(this.fileToUpload)
    },
    createImage(file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.image = e.target.result
      }

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    upload() {
      this.isLoading = true
      const formData = new FormData()
      formData.append('file', this.fileToUpload)
      this.$http.post(`media`, formData).then(
        response => {
          this.image = null
          this.file = response.data
          this.$emit('input', response.data)
          // dismiss modal
          this.actionModal('hide')
          this.isLoading = false
        },
        err => {
          // error callback
          console.log(err)
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UploadFileInput.vue